<template>
  <div class="fieldset">
    <h3 class="fieldset-heading">Instruction Completed</h3>
    <p>Your details have been passed to the conveyance in company, they will contact you over the next few days with the next steps.</p>
  </div>
</template>

<script>
import {fieldsetHelpers} from "../fieldsetHelpers";


export default {
  name: 'Complete',
  components: {},
  mixins: [fieldsetHelpers],
  props: {
    value: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      label: 'Complete', // used for steps progress
      disableStepsNavigation: false
    }
  },
  computed: {
    form: {
      set(value) {
        this.$emit('input', value)
      },
      get() {
        return this.value
      }
    }
  }
};
</script>
